var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { Component, Vue } from 'vue-property-decorator';
import UserHeaderContent from '../components/UserControlHeaderContent.vue';
import { connect } from '@/overmind';
import { mixpanelTracking } from '@/services/mixpanel';
import IconEye from '@/components/Icons/iconEye.vue';
import { resetPassword } from '@/clients/auth';
import { NotificationService } from '@/services/NotificationService';
let UserChangePasswordContainer = class UserChangePasswordContainer extends Vue {
    constructor() {
        super(...arguments);
        this.title = 'Alterar a senha';
        this.loading = false;
        this.newPassword = '';
        this.confirmPassword = '';
        this.actualPassword = '';
        this.dontPassword = true;
        this.showOldPassword = false;
        this.showNewPassword = false;
        this.showConfirmPassword = false;
        this.updatedPassword = false;
        this.notChanged = true;
        this.passwordSuccess = false;
        this.waitingReset = false;
    }
    cleanForm() {
        this.newPassword = '';
        this.confirmPassword = '';
        this.actualPassword = '';
        setTimeout(() => {
            // @ts-ignore
            this.$refs.changePasswordForm.resetValidation();
        }, 300);
    }
    async confirm() {
        this.loading = true;
        // @ts-ignore
        const valid = await this.$refs.changePasswordForm.validate();
        if (valid) {
            // @ts-ignore
            const result = await this.actions.changePassword({
                create_password: false,
                /*eslint-disable */ old_password: this.actualPassword,
                password: this.newPassword,
                password_confirmation: this.confirmPassword /*eslint-disable */,
            });
            this.loading = false;
            if (result && result.status == 200) {
                this.cleanForm();
                this.updatedPassword = true;
            }
        }
        this.loading = false;
    }
    mounted() {
        this.$gtag.pageview({ page_path: this.$route.path });
        mixpanelTracking('painel do usuário: Abriu a aba Alterar senha');
        //@ts-ignore
        if (this.state && !this.state.have_password) {
            this.title = 'Criar senha';
            this.dontPassword = false;
        }
    }
    async resetPassword() {
        this.waitingReset = true;
        // @ts-ignore
        const user = this.$auth.user();
        try {
            await resetPassword(user.email);
            NotificationService.success('Sucesso', 'Enviamos um email com o link de cadastro de sua senha nova');
        }
        catch (e) {
            console.log(e);
            NotificationService.error('Error', 'Não foi possível enviar sua requisição de mudança de senha');
        }
        this.waitingReset = false;
    }
};
UserChangePasswordContainer = __decorate([
    Component(connect(({ state, actions }) => ({
        usersState: state.users,
        actions: actions.users,
    }), {
        components: {
            UserHeaderContent,
            IconEye,
        },
    }))
], UserChangePasswordContainer);
export default UserChangePasswordContainer;
